import { SET_SUPPLIERS, SET_SUPPLIER } from "../../mutations.type";

export default {
  [SET_SUPPLIERS](state, suppliers) {
    state.suppliers = suppliers;
  },
  [SET_SUPPLIER](state, supplier) {
    state.suppliers = supplier;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/mutations.js